import React from 'react';
import { ArrowRightIcon, BatteryChargingIcon, PackageIcon, ClockIcon, WeightIcon } from 'lucide-react';
import { Button } from '../ui/Button';
import { useTranslation } from '../../lib/i18n';
interface HeroProps {
  onRequestQuote: () => void;
}
export function Hero({
  onRequestQuote
}: HeroProps) {
  const {
    t,
    lang
  } = useTranslation();
  const en = lang === 'en';
  return <section className="relative min-h-[700px] md:min-h-[900px] flex items-center bg-dark-bg" data-id="element-237" data-mp="aoa795krb1qs">
      <div className="absolute inset-0 overflow-hidden" data-id="element-238" data-mp="5pqhsv6yf7to">
        <video autoPlay loop muted playsInline ref={el => {
        // Guarantee the background video is silent regardless of browser
        // quirks (the React `muted` attribute is not always applied).
        if (el) {
          el.muted = true;
          el.volume = 0;
        }
      }} className="absolute inset-0 w-full h-full object-cover" data-id="element-239" data-mp="5o5n95kn3ovt">
          <source src="https://cdn.magicpatterns.com/uploads/szwwdiBXCG3exkg6vKfMeS/POZADINA.mp4" type="video/mp4" data-id="element-240" data-mp="1mvt4ppp40f10" />
        </video>
        <div className="absolute inset-0 bg-black/65" data-id="element-241" data-mp="1rtci6ndzgnrw" />
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-32" data-id="element-242" data-mp="1czgamqpnjz5q">
        <div className="max-w-4xl" data-id="element-243" data-mp="1hyavrzb3dzt0">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-white leading-tight mb-10 md:mb-14" data-id="element-244" data-mp="1hzc6u3s3ymaq">
            {t.hero.title}
            <br data-id="element-245" data-mp="2am6qiyh3phn5" />
            <span className="text-brand-yellow" data-id="element-246" data-mp="2aklv76mypuo8">{t.hero.titleHighlight}</span>
          </h1>

          <div className="flex flex-col sm:flex-row gap-3 md:gap-4 mb-14 md:mb-20" data-id="element-247" data-mp="1vw952qak361n">
            <Button variant="primary" size="lg" className="w-full sm:w-auto" onClick={() => document.getElementById('products')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-248" data-mp="20vc33qs4cc04">
              {t.hero.btnProducts}
              <ArrowRightIcon className="w-5 h-5 ml-2 inline" data-id="element-249" data-mp="336aqr1723p0t" />
            </Button>
            <Button variant="outline" size="lg" className="w-full sm:w-auto" onClick={onRequestQuote} data-id="element-250" data-mp="2y9tpr6erdg6b">
              {t.hero.btnQuote}
            </Button>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4" data-id="element-251" data-mp="2k9iza4hd23lo">
            {[{
            icon: <WeightIcon className="w-7 h-7 text-brand-yellow flex-shrink-0" data-id="element-252" data-mp="2fhrhaic9t675" />,
            value: en ? 'up to 250 kg' : lang === 'ru' ? 'до 250 кг' : 'do 250 kg',
            label: t.hero.capacity
          }, {
            icon: <BatteryChargingIcon className="w-7 h-7 text-brand-yellow flex-shrink-0" data-id="element-253" data-mp="1wk86b9695di3" />,
            value: '48V 36Ah',
            label: t.hero.battery
          }, {
            icon: <ClockIcon className="w-7 h-7 text-brand-yellow flex-shrink-0" data-id="element-254" data-mp="gzpd451uczhy" />,
            value: t.hero.runtimeValue,
            label: t.hero.runtime
          }, {
            icon: <PackageIcon className="w-7 h-7 text-brand-yellow flex-shrink-0" data-id="element-255" data-mp="pzch8ylygjep" />,
            value: t.hero.deliveryValue,
            label: t.hero.delivery
          }].map((item, i) => <div key={i} className="flex items-center space-x-3 bg-dark-surface bg-opacity-80 border border-dark-border rounded-industrial p-3 md:p-4" data-id="element-256" data-mp="2buk0njx8t4c" data-mpi={i}>
                {item.icon}
                <div data-id="element-257" data-mp="36pt0s2byzz9q">
                  <div className="text-base font-bold text-white" data-id="element-258" data-mp="36o84a763i698">
                    {item.value}
                  </div>
                  <div className="text-xs text-gray-400" data-id="element-259" data-mp="2rn1df4vo4jqv">{item.label}</div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}